<template>
  <v-app style="background-color: lightgray;">
    <AutoLogout></AutoLogout>
    <v-toolbar
      v-if="!showFullImageDialog"
      class="toolbar"
      style="background-color:transparent;"
      app
      height="45"
      flat
      fixed
    >
      <div class="iconBorder">
        <a @click="backToPrevPage()">
          <v-icon style="color:white;font-size:30px;padding-left:2.5px;padding-top:2px;">arrow_back</v-icon>
        </a>
      </div>
    </v-toolbar>

    <div v-if="!showFullImageDialog" class="itemDetailContain">
      <div class="itemDetailImgContain">
        <img :src="smallSizeImg" class="itemDetailImg" @click="showFullImage()" />
      </div>

      <div class="itemDetailCardContain">
        <!-- //Price & Name -->
        <v-card>
          <v-card-title style="padding:5px;">
            <h3 style="font-size:25px;">{{itemName}}</h3>
          </v-card-title>
        </v-card>

        <div style="margin:3px;"></div>

        <!-- //Desp -->
        <v-card v-if="itemDesp != ''">
          <v-card-title style="padding:5px;">
            <!-- <p style="margin:0px;font-size:16px;white-space: pre-line;">{{itemDesp}}</p> -->
            <viewer :initial-value="itemDesp" />
          </v-card-title>
        </v-card>

        <div style="margin:3px;"></div>

        <!-- //Selection -->
        <v-card>
          <v-card-title
            v-if="itemSellingFast"
            class="subheading font-weight-bold"
            style="padding:10px 0px 0px 5px;"
          >
            <p class="sellingFast" style="font-size:16px;">Selling Fast</p>
          </v-card-title>
          <v-card-title v-if="selectedItemPrc != ''" class="itemPriceColor">
            <h2>RM {{itemPriceWTax + propItemPriceWTax}}</h2>
          </v-card-title>
          <v-card-title v-if="selectedItemPrc == ''" class="itemPriceColor">
            <h2>RM {{itemPriceWTax}}</h2>
          </v-card-title>
          <!-- /////Prc -->
          <v-card-title style="padding:5px;">
            <div
              v-if="onlyOneSizeToSelect == false"
              class="col-xs-12 col-md-12"
              style="padding:0px;"
            >
              <p style="margin:0px;font-size:16px;">
                Size :
                <span style="font-size:18px;">{{selectedItemPrc}}</span>
              </p>
              <div
                v-for="(itemPrc, i) in ListOfPrice"
                :key="itemPrc.ID"
                style="display: inline-block;"
              >
                <b-button
                  v-if="ListOfPrice.length>1"
                  :variant="outline"
                  :pressed.sync="itemPrc.state"
                  class="pull-left shadow-none"
                  style="margin:10px; padding-left: 12px; padding-right: 12px; width:auto; min-width:45px;"
                  @click="selectPrc(itemPrc.PrcName,  i)"
                >{{itemPrc.PrcName}}</b-button>

                <b-button
                  v-if="ListOfPrice.length == 1 && prcType == 1"
                  :variant="outline"
                  class="pull-left"
                  style="margin:10px; padding-left: 12px; padding-right: 12px; width:auto; min-width:45px;"
                >{{itemPrc.PrcName}}</b-button>
              </div>
              <br />
            </div>
            <div
              v-if="onlyOneSizeToSelect == true"
              class="col-xs-12 col-md-12"
              style="padding:0px;"
            >
              <p style="margin:0px;font-size:16px;">
                Size :
                <span style="font-size:18px;">{{selectedItemPrc}}</span>
              </p>
              <!-- <div v-for="itemPrc in ListOfPrice" :key="itemPrc.ID" style="display: inline-block;">
                <b-button
                  v-if="ListOfPrice.length == 1 && prcType == 1"
                  :variant="outline"
                  class="pull-left"
                  style="margin:10px; padding-left: 12px; padding-right: 12px; width:auto; min-width:45px;"
                >{{itemPrc.PrcName}}</b-button>
              </div>-->
              <br />
            </div>
          </v-card-title>

          <!-- /////Price Rate Msg -->
          <v-card-title
            v-if="prcType == 1 && (priceRateMsg != '' && priceRateMsg != undefined )"
            style="padding:5px;"
          >
            <p style="margin:0px;font-size:16px;color:red;margin-top:-20px;">{{priceRateMsg}}</p>
          </v-card-title>

          <!-- /////Property -->
          <v-card-title v-if="ListOfProp.length>0" style="padding:5px;">
            <p style="margin:0px;font-size:16px;">Property :</p>
            <p
              v-if="selectedItemPropList.length>0"
              style="margin:0px;font-size:16px;"
            >{{selectedItemPropList | ArrangeTxt(selectedItemPropList)}}</p>
            <div class="col-xs-12 col-md-12">
              <div v-for="itemProp in ListOfProp" :key="itemProp.ID" style="display: inline-block;">
                <input
                  v-if="itemProp.ItemPropBtnType == 0"
                  :id="itemProp.PropName"
                  v-model="itemProp.state"
                  type="checkbox"
                  style="display: none;"
                />
                <label :for="itemProp.PropName" style="margin-bottom:0px;">
                  <div
                    class="pull-left choices noselect"
                    style="padding-left: 12px; padding-right: 12px; width:auto; min-width:100px;"
                    @click="selectProp(itemProp.PropName,itemProp.ItemPropPrcWTax, itemProp.ItemPropBtnType)"
                  >{{itemProp.PropName}}</div>
                </label>
              </div>
              <br />
            </div>
          </v-card-title>

          <!-- /////Qty -->
          <v-card-title style="padding:5px;">
            <p style="font-size:16px;">Quantity</p>
            <p v-if="prcType == 1">
              :
              <strong>{{ selectedItemQty }}</strong>
            </p>
            <div class="col-xs-12 col-md-12">
              <button
                v-if="prcType != 1"
                class="btn btn-danger setBtnSz"
                type="submit"
                @click="sub()"
              >-</button>
              <button v-if="prcType != 1" class="btn iPrice setBtnSz" type="number">
                <input
                  v-model="selectedItemQty"
                  type="tel"
                  style="width:40px;padding:5px;"
                  class="form-control"
                  name="selectedItemQty"
                  autocomplete="nope"
                  @input="selectedItemQty = $event.target.value.replace(/[^0-9]/g,'')"
                  @change="chgQty(selectedItemQty)"
                />
              </button>
              <button
                v-if="prcType != 1"
                class="btn btn-success setBtnSz"
                style="margin-right: 20px;"
                type="submit"
                @click="add()"
              >+</button>
              <h5
                v-if="selectedPrcRemainQty>0 && selectedPrcRemainQty!= Infinity"
                style="display:inline;"
              >{{selectedPrcRemainQty}} Available</h5>
              <h5
                v-if="selectedPrcRemainQty==0 && selectedPrcNoRemainQtyTxt"
                style="display:inline;"
              >Sold Out</h5>
            </div>
          </v-card-title>

          <!-- /////Remark -->
          <v-card-title style="padding:5px;padding-top:15px;">
            <p style="margin:0px;font-size:16px;">Remark :</p>
            <div class="col-xs-12 col-md-12">
              <div>
                <input
                  v-model="itemRemark"
                  style="width:100%;"
                  type="text"
                  class="form-control searchBar"
                  autocomplete="nope"
                  name="itemRemark"
                  placeholder="Remark"
                  @input="itemRemark = $event.target.value"
                />
              </div>
              <br />
            </div>
          </v-card-title>

          <!-- /////Add Cart / Sold Out -->
          <v-card-title
            v-if="(itemSoldOut == false && itemPriceSoldOut == false) || selectedPrcRemainQtyUnlimited"
            style="padding:5px;margin-top:10px;"
          >
            <button
              class="btn addCartBtn"
              style="width:100%;height:35px;margin-bottom:15px;"
              @click="EditCart()"
            >Edit Item</button>
          </v-card-title>
          <v-card-title
            v-if=" (itemSoldOut || itemPriceSoldOut)"
            style="padding:5px;margin-top:30px;"
          >
            <button disabled class="btn addCartBtn" style="width:100%;">Sold Out</button>
          </v-card-title>
          <!-- <v-card-title>
        <p style="margin-bottom:15px;"></p>
          </v-card-title>-->
        </v-card>
      </div>
    </div>

    <v-toolbar
      v-if="showFullImageDialog"
      class="toolbar"
      style="background-color:transparent;"
      app
      height="45"
      flat
      fixed
    >
      <div class="iconBorder">
        <a @click="closeFullImgDialog()">
          <v-icon style="color:white;font-size:30px;padding-left:2.5px;padding-top:2px;">close</v-icon>
        </a>
      </div>
    </v-toolbar>

    <v-layout v-if="showFullImageDialog" class="text-xs-center">
      <img
        :src="fullSizeImg"
        style="padding:5px;float: none;margin: auto;width:100%;heigth:auto;"
        @click="closeFullImgDialog()"
      />
    </v-layout>

    <v-snackbar v-model="snackbar" :timeout="timeout" :color="colorTxt" multi-line="multi-line">
      <h3>{{snackbarMsg}}</h3>
    </v-snackbar>

    <v-layout class="text-xs-center">
      <v-dialog v-model="multiItemDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{multiItemDialogInfo.Name}}</v-card-title>
          <v-card-text style="padding-bottom:0px;">
            <h5 style="font-size:18px;">{{$t('Price')}}: RM {{multiItemDialogInfo.Price}}</h5>
            <h5>
              <span style="font-size:18px;">{{$t('Quantity')}}:</span>
              <button
                style="margin-left:5px;"
                class="btn btn-danger setBtnSz"
                type="submit"
                @click="setPropQty(mdfItemPropQty, 'sub')"
              >-</button>
              <button style="padding:0px;" class="btn iPrice setBtnSz" type="number">
                <input
                  v-model="mdfItemPropQty"
                  type="tel"
                  style="width:40px;padding:5px;"
                  class="form-control"
                  autocomplete="nope"
                  name="mdfItemPropQty"
                  @input="mdfItemPropQty = $event.target.value.replace(/[^0-9]/g,'')"
                  @change="setPropQty(mdfItemPropQty, 'change')"
                />
              </button>
              <button
                class="btn btn-success setBtnSz"
                style="margin-right: 20px;"
                type="submit"
                @click="setPropQty(mdfItemPropQty, 'add')"
              >+</button>
            </h5>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="error"
              flat
              @click="setMultiItemProQty(multiItemDialogInfo.Name, multiItemDialogInfo.Price, 0)"
            >{{$t('Clear')}}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="closeMultiItemDialog()">{{$t('Cancel')}}</v-btn>
            <v-btn
              color="primary"
              flat
              @click="setMultiItemProQty(multiItemDialogInfo.Name, multiItemDialogInfo.Price, mdfItemPropQty)"
            >{{$t('Okay')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
import $ from 'jquery'
import JS from './JsonService'
import Vue from 'vue'
import globalVar from './GlobalVar.js'
import VersionDialog from '../src/VersionNotMatchDialog'
import VueSession from 'vue-session'
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import AutoLogout from './AutoLogout'
import { Viewer } from '@toast-ui/vue-editor'

Vue.use(VueSession, { persist: true })
export default {
  components: {
    VersionDialog,
    AutoLogout,
    viewer: Viewer
  },
  filters: {
    currency(amount) {
      const amt = Number(amount)
      return amt
    },
    ArrangeTxt(txtArray) {
      var txtAry = String(txtArray)
      txtAry = txtAry.replace(/[,]/g, ', ')
      return txtAry
    }
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['itemId'],
  data() {
    return {
      mCode: '',
      cartList: [],
      currentItemId: '',
      successLogin: '',
      fullSizeImg: '',
      smallSizeImg: '',
      itemName: '',
      itemDesp: '',
      itemPrice: 0,
      itemPriceWTax: 0,
      itemSoldOut: true,
      itemSellingFast: false,
      itemPriceSoldOut: false,
      ListOfPrice: [],
      ListOfQty: [],
      ListOfProp: [],
      onlyOneSizeToSelect: false,
      selectedItemPrc: '',
      selectedPrcId: '',
      selectedPrcRemainQty: 0,
      selectedPrcNoRemainQtyTxt: false,
      selectedItemPropList: [],
      selectedItemQty: Number,
      selectedPrcRemainQtyUnlimited: false,
      selectedItemPropPrice: Number,
      snackbar: false,
      timeout: 2000,
      snackbarMsg: '',
      colorTxt: '',
      InfoOfCart: [],
      sendRefId: '',
      totalCartItemQty: 0,
      newItmQty: 0,
      addProp: false,
      propItemPrice: 0,
      propItemPriceWTax: 0,
      selectedPropPrice: [],
      selectedPropPriceWTax: [],
      outline: '',
      pickerColor: '',
      showFullImageDialog: false,
      bigPic: '',
      prcType: 0,
      priceRateMsg: '',
      itemRemark: '',
      versionError: false,
      multiItemDialog: false,
      multiItemDialogInfo: [],
      mdfItemPropQty: 1,
      selectedItemMultiPropList: []
    }
  },
  created() {
    //sessionStorage.setItem('needBackPrevPosition', false)
    // console.log(this.itemId)
    $(window).ready(function() {
      $(this).scrollTop(0)
    })

    //get searchedInfo
    const key = 'searchedInfo'
    if (sessionStorage.getItem(key)) {
      const value = sessionStorage.getItem(key)
      // console.log(value)
      this.searchedData = JSON.parse(value)
      console.log(this.searchedData)
      this.mCode = this.searchedData.kp
      this.priceRatecMsg = this.searchedData.ov
    }

    //get Id
    if (this.itemId != undefined || this.itemId != null || this.itemId != '') {
      this.currentItemId = this.itemId
      console.log(this.currentItemId)
    } else {
      if (globalVar.mode == 'normal') {
        this.$router.replace('/')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'Search', params: { mchdCode: mchCd } })
      }
    }

    //get temp Name
    this.setTempItem()

    //set selectedItemQty && selectedItemPropPrice
    this.selectedItemQty = 1
    this.selectedItemPropPrice = 0

    //Check login
    if (sessionStorage.getItem('successLogin')) {
      const value = sessionStorage.getItem('successLogin')
      var status = JSON.parse(value)
      console.log(status)
      this.successLogin = status.successLogin
      console.log('login status: ', this.successLogin)
    }

    //Total Cart Item Qty
    const valueQty = sessionStorage.getItem('TotalCartItemQty')
    this.totalCartItemQty = valueQty
    // console.log(this.totalCartItemQty)

    //getData
    this.getCurrentItemDetail()

    //getAllSelectedCart
    const allCart = sessionStorage.getItem('cart')
    this.cartList = JSON.parse(allCart)
    console.log(JSON.parse(allCart))
    if (this.cartList != null) {
      if (this.cartList.length > 0) {
        this.updatedCartList(this.cartList)
      }
    }
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    showFullImage() {
      if (this.fullSizeImg != '' && this.fullSizeImg != null) {
        this.showFullImageDialog = true
      } else {
        this.showFullImageDialog = false
      }
    },
    closeFullImgDialog() {
      this.showFullImageDialog = false
    },
    setTempItem() {
      const value = sessionStorage.getItem('tempName')
      var status = JSON.parse(value)
      // console.log(status)
      this.outline = status.outline
      this.pickerColor = status.color
    },
    getCurrentItemDetail() {
      this.versionError = false
      var version = sessionStorage.getItem('version')
      const url = 'Order/GetItemInfo'
      const parameter = {
        av: version,
        kp: this.mCode,
        kt: this.currentItemId
      }
      console.log(parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log('data : ', response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ListOfItem.oc != true) {
              this.getListOfItem(response.data)
              this.getListOfQty(response.data)
              this.getListOfPrice(response.data)
              this.getListOfProp(response.data)
            } else {
              if (globalVar.mode == 'normal') {
                this.$router.replace('/')
              } else if (globalVar.mode == 'lite') {
                var mchCd = sessionStorage.getItem('paramMchdCode')
                this.$router.replace({
                  name: 'Search',
                  params: { mchdCode: mchCd }
                })
              }
            }
          }
        })
        .catch(error => {
          this.versionError = false
          console.log(error)
        })
    },
    updatedCartList(cartList) {
      this.InfoOfCart = cartList
    },
    getListOfItem(data) {
      if (data.ListOfItem[0].kx == '' || data.ListOfItem[0].kx == null) {
        var defaultImg = require('./assets/ImgNotFound.png')
        data.ListOfItem[0].kx = defaultImg
      } else {
        data.ListOfItem[0].kx = JS.checkImg(data.ListOfItem[0].kx)
      }
      if (data.ListOfItem[0].kw == '' || data.ListOfItem[0].kw == null) {
        var defaultImgSmall = require('./assets/ImgNotFound.png')
        data.ListOfItem[0].kw = defaultImgSmall
      } else {
        data.ListOfItem[0].kw = JS.checkImg(data.ListOfItem[0].kw)
      }

      this.smallSizeImg = data.ListOfItem[0].kw
      this.fullSizeImg = data.ListOfItem[0].kx

      this.itemName = data.ListOfItem[0].ku
      this.itemDesp = data.ListOfItem[0].kv
      this.itemPrice = data.ListOfItem[0].lp
      this.itemSoldOut = data.ListOfItem[0].oc
      this.itemSellingFast = data.ListOfItem[0].sd
      this.itemPriceWTax = data.ListOfItem[0].lp
      // console.log(this.fullSizeImg)
    },
    getListOfPrice(data) {
      // console.log(data.ListOfPrice)
      this.ListOfPrice = []

      for (let i = 0; i < data.ListOfPrice.length; i++) {
        const itemPrc = []
        itemPrc.PrcID = data.ListOfPrice[i].ky
        itemPrc.ItemID = data.ListOfPrice[i].kt
        itemPrc.PrcName = data.ListOfPrice[i].kz
        itemPrc.Price = data.ListOfPrice[i].lp
        itemPrc.PriceWTax = data.ListOfPrice[i].ro
        itemPrc.state = false
        this.ListOfPrice.push(itemPrc)
      }
      console.log('Item price data: ', this.ListOfPrice)

      if (this.ListOfPrice.length > 0) {
        this.prcType = Number(data.ListOfPrice[0].ou)
      }
      if (this.ListOfPrice.length == 1) {
        this.onlyOneSizeToSelect = true
        this.selectPrc(this.ListOfPrice[0].PrcName, 0)
      }

      const editIndex = sessionStorage.getItem('editItemDetailIndex')
      console.log(this.InfoOfCart[editIndex])
      this.selectedItemPrc = this.InfoOfCart[editIndex].size
      for (let i = 0; i < this.ListOfPrice.length; i++) {
        if (this.ListOfPrice[i].PrcName == this.InfoOfCart[editIndex].size) {
          this.ListOfPrice[i].state = true
          this.selectPrc(this.selectedItemPrc, i)
        }
      }
    },
    getListOfQty(data) {
      // console.log(data.ListOfQty)
      this.ListOfQty = []
      for (let i = 0; i < data.ListOfQty.length; i++) {
        const itemQty = []
        itemQty.QtyID = data.ListOfQty[i].or
        itemQty.ItemID = data.ListOfQty[i].kt
        itemQty.PrcID = data.ListOfQty[i].ky
        itemQty.PropId = data.ListOfQty[i].oo
        itemQty.Quantity = data.ListOfQty[i].lo
        this.ListOfQty.push(itemQty)
      }
      console.log('Item Qty data: ', this.ListOfQty)
      const editIndex = sessionStorage.getItem('editItemDetailIndex')
      console.log(this.InfoOfCart[editIndex])
      this.selectedItemQty = this.InfoOfCart[editIndex].qty
    },
    getListOfProp(data) {
      this.ListOfProp = []
      if (data.ListOfProp.length > 0) {
        for (let i = 0; i < data.ListOfProp.length; i++) {
          const itemProp = []
          itemProp.PropName = data.ListOfProp[i].ez
          itemProp.ItemID = data.ListOfProp[i].kt
          itemProp.ItemPropPrc = data.ListOfProp[i].lp
          itemProp.PropId = data.ListOfProp[i].oo
          itemProp.ItemPropPrcWTax = data.ListOfProp[i].ro
          itemProp.ItemPropBtnType = data.ListOfProp[i].gm
          itemProp.state = false
          this.ListOfProp.push(itemProp)
        }
      }
      console.log('Item prop data: ', this.ListOfProp)

      const editIndex = sessionStorage.getItem('editItemDetailIndex')
      console.log(this.InfoOfCart[editIndex])
      this.selectedItemPropList = this.InfoOfCart[editIndex].prop
      for (let j = 0; j < this.InfoOfCart[editIndex].prop.length; j++) {
        for (let i = 0; i < this.ListOfProp.length; i++) {
          //Once
          if (
            this.InfoOfCart[editIndex].prop[j] == this.ListOfProp[i].PropName
          ) {
            this.ListOfProp[i].state = true
          }

          //Multi
          if (this.InfoOfCart[editIndex].prop[j].lastIndexOf(' X ') >= 0) {
            if (
              this.InfoOfCart[editIndex].prop[j].startsWith(this.ListOfProp[i])
            ) {
              this.selectedItemMultiPropList.push(
                this.InfoOfCart[editIndex].prop[j]
              )

              let unique = {}
              this.selectedItemMultiPropList.forEach(function(i) {
                if (!unique[i]) {
                  unique[i] = true
                }
              })
              this.selectedItemMultiPropList = Object.keys(unique)
              //console.log(this.selectedItemMultiPropList)
            }
          }

          //Remark
          if (j == this.InfoOfCart[editIndex].prop.length - 1) {
            // console.log(this.InfoOfCart[editIndex].prop[j])
            // console.log(this.ListOfProp[i].PropName)
            if (
              this.InfoOfCart[editIndex].prop[j] == this.ListOfProp[i].PropName
            ) {
              this.itemRemark = ''
              break
            } else {
              if (i == this.ListOfProp.length - 1) {
                if (
                  this.InfoOfCart[editIndex].prop[j].substr(
                    0,
                    this.InfoOfCart[editIndex].prop[j].lastIndexOf(' X ')
                  ) != this.ListOfProp[i].PropName
                ) {
                  // console.log(
                  //   this.InfoOfCart[editIndex].prop[j].substr(
                  //     0,
                  //     this.InfoOfCart[editIndex].prop[j].lastIndexOf(' X ')
                  //   )
                  // )
                  // console.log(this.ListOfProp[i].PropName)
                  // console.log(
                  //   this.InfoOfCart[editIndex].prop[j].lastIndexOf(' X ')
                  // )
                  // console.log(
                  //   this.InfoOfCart[editIndex].prop[j].substr(
                  //     0,
                  //     this.InfoOfCart[editIndex].prop[j].lastIndexOf(' X ')
                  //   )
                  // )
                  if (
                    this.InfoOfCart[editIndex].prop[j].lastIndexOf(' X ') < 0
                  ) {
                    this.itemRemark = this.InfoOfCart[editIndex].prop[j]
                    this.InfoOfCart[editIndex].prop.splice(
                      this.InfoOfCart[editIndex].prop.indexOf(
                        this.InfoOfCart[editIndex].prop[j]
                      ),
                      1
                    )
                  } else {
                    let fullList = []
                    for (let k = 0; k < this.ListOfProp.length; k++) {
                      fullList.push(this.ListOfProp[k].PropName)
                    }
                    let alreadyInclude = fullList.includes(
                      this.InfoOfCart[editIndex].prop[j].substr(
                        0,
                        this.InfoOfCart[editIndex].prop[j].lastIndexOf(' X ')
                      )
                    )

                    // console.log(fullList)
                    // console.log(alreadyInclude)

                    if (alreadyInclude == false) {
                      this.itemRemark = this.InfoOfCart[editIndex].prop[j]
                      this.InfoOfCart[editIndex].prop.splice(
                        this.InfoOfCart[editIndex].prop.indexOf(
                          this.InfoOfCart[editIndex].prop[j]
                        ),
                        1
                      )
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.setAllPrice()
    },
    selectPrc(prc, index) {
      // console.log(index)
      // console.log(this.ListOfPrice[index].state)
      // console.log(this.ListOfPrice)
      for (let i = 0; i < this.ListOfPrice.length; i++) {
        if (i != index) {
          this.ListOfPrice[i].state = false
        }
      }
      if (this.ListOfPrice[index].state == false) {
        this.ListOfPrice[index].state = true
      }
      // console.log(prc)
      this.selectedItemPrc = prc
      //this.selectedItemQty = 1

      if (prc != '' && prc != undefined) {
        for (let i = 0; i < this.ListOfPrice.length; i++) {
          if (prc == this.ListOfPrice[i].PrcName) {
            this.selectedPrcId = this.ListOfPrice[i].PrcID
            this.itemPrice = this.ListOfPrice[i].Price
            this.itemPriceWTax = this.ListOfPrice[i].PriceWTax
          }
        }
      }
      // console.log(this.selectedPrcId)

      if (this.selectedPrcId != '' && this.selectedPrcId != undefined) {
        // console.log(this.ListOfQty.length)
        if (this.ListOfQty.length == 0) {
          this.itemPriceSoldOut = false
          if (this.itemSoldOut) {
            this.selectedPrcRemainQty = 0
            this.selectedItemQty = 0
            this.selectedPrcNoRemainQtyTxt = true
          } else {
            this.selectedPrcRemainQtyUnlimited = true
            this.selectedPrcRemainQty = Infinity
          }
        } else {
          this.selectedPrcRemainQtyUnlimited = false
          for (let j = 0; j < this.ListOfQty.length; j++) {
            // console.log(this.ListOfQty[j].Quantity)
            if (this.selectedPrcId == this.ListOfQty[j].PrcID) {
              if (this.ListOfQty[j].Quantity == 0) {
                this.selectedItemQty = 0
                this.selectedPrcRemainQty = 0
                this.selectedPrcNoRemainQtyTxt = true
                this.itemPriceSoldOut = true
              } else {
                this.itemPriceSoldOut = false
                if (this.itemSoldOut) {
                  this.selectedPrcRemainQty = 0
                  this.selectedItemQty = 0
                  this.selectedPrcNoRemainQtyTxt = true
                } else {
                  this.selectedPrcRemainQty = this.ListOfQty[j].Quantity
                }
              }
            } else {
              this.selectedPrcRemainQtyUnlimited = true
              this.selectedPrcRemainQty = Infinity
            }
          }
        }
      }
      // console.log(this.selectedPrcRemainQty)
    },
    selectProp(prop, price, btnType) {
      this.multiItemDialogInfo = []
      if (btnType != 3) {
        this.multiItemDialog = false
        var checkProp = 0
        if (prop != '' && prop != undefined) {
          if (this.selectedItemPropList.length == 0) {
            this.selectedItemPropList.push(prop)
            this.addProp = true
          } else {
            if (this.selectedItemPropList.length != 0) {
              for (let i = 0; i < this.selectedItemPropList.length; i++) {
                console.log(this.selectedItemPropList[i])
                console.log(this.selectedItemPropList.length)
                if (prop == this.selectedItemPropList[i]) {
                  // console.log('already inside array')
                  this.selectedItemPropList.splice(
                    this.selectedItemPropList.indexOf(
                      this.selectedItemPropList[i]
                    ),
                    1
                  )
                  checkProp = '2'
                  this.addProp = false
                  break
                }
              }
              if (checkProp == '') {
                this.selectedItemPropList.push(prop)
                this.addProp = true
              }
            }
          }
        }
      } else {
        this.mdfItemPropQty = 1
        if (this.selectedItemMultiPropList.length > 0) {
          for (let i = 0; i < this.selectedItemMultiPropList.length; i++) {
            if (
              this.selectedItemMultiPropList[i].substr(
                0,
                this.selectedItemMultiPropList[i].lastIndexOf(' X ')
              ) == prop
            ) {
              this.mdfItemPropQty = this.selectedItemMultiPropList[i].split(
                ' X '
              )[this.selectedItemMultiPropList[i].split(' X ').length - 1]
            }
          }
        }

        this.multiItemDialogInfo = {
          Name: prop,
          Price: price,
          Qty: this.mdfItemPropQty
        }
        //console.log(this.multiItemDialogInfo)
        this.multiItemDialog = true
      }
      console.log(this.selectedItemPropList)
      this.setAllPrice()
    },
    setPropQty(val, type) {
      if (val > 0) {
        if (type == 'add') {
          this.mdfItemPropQty = Number(this.mdfItemPropQty) + 1
        } else if (type == 'sub') {
          if (val > 1) {
            this.mdfItemPropQty = Number(this.mdfItemPropQty) - 1
          }
        } else if (type == 'change') {
          this.mdfItemPropQty = Number(val)
        }
      } else {
        this.mdfItemPropQty = 1
      }
    },
    setMultiItemProQty(mProp, mPrice, multiQty) {
      if (multiQty > 0) {
        let price = Number(mPrice.toFixed(2) * multiQty)
        let prop = mProp + ' X ' + multiQty
        this.multiItemDialogInfo = { Name: prop, Price: price, Qty: multiQty }
        console.log(this.multiItemDialogInfo)

        var checkProp = 0
        if (prop != '' && prop != undefined) {
          if (this.selectedItemPropList.length == 0) {
            this.selectedItemMultiPropList.push(prop)
            this.selectedItemPropList.push(prop)
            this.addProp = true
          } else {
            if (this.selectedItemPropList.length != 0) {
              for (let i = 0; i < this.selectedItemPropList.length; i++) {
                console.log(this.selectedItemPropList[i])
                console.log(this.selectedItemPropList.length)
                if (this.selectedItemPropList[i].startsWith(mProp)) {
                  // console.log('already inside array')
                  this.selectedItemPropList[i] = prop
                  checkProp = '2'
                  this.addProp = false
                  break
                }
              }
              for (let i = 0; i < this.selectedItemMultiPropList.length; i++) {
                if (this.selectedItemMultiPropList[i].startsWith(mProp)) {
                  // console.log('already inside array')
                  this.selectedItemMultiPropList[i] = prop
                  checkProp = '2'
                  this.addProp = false
                  break
                }
              }
              if (checkProp == '') {
                this.selectedItemPropList.push(prop)
                this.selectedItemMultiPropList.push(prop)
                this.addProp = true
              }
            }
          }
        }
        this.closeMultiItemDialog()
      } else {
        if (this.selectedItemPropList.length != 0) {
          for (let i = 0; i < this.selectedItemPropList.length; i++) {
            console.log(this.selectedItemPropList[i])
            console.log(this.selectedItemPropList.length)
            if (this.selectedItemPropList[i].startsWith(mProp)) {
              // console.log('already inside array')
              this.selectedItemPropList.splice(
                this.selectedItemPropList.indexOf(this.selectedItemPropList[i]),
                1
              )
              checkProp = '2'
              this.addProp = false
              break
            }
          }
          for (let i = 0; i < this.selectedItemMultiPropList.length; i++) {
            if (this.selectedItemMultiPropList[i].startsWith(mProp)) {
              // console.log('already inside array')
              this.selectedItemMultiPropList.splice(
                this.selectedItemMultiPropList.indexOf(
                  this.selectedItemMultiPropList[i]
                ),
                1
              )
              checkProp = '2'
              this.addProp = false
              break
            }
          }
          if (checkProp == '') {
            this.selectedItemPropList.push(mProp)
            this.selectedItemMultiPropList.push(mProp)
            this.addProp = true
          }
        }
        this.closeMultiItemDialog()
      }
      this.setAllPrice()
    },
    closeMultiItemDialog() {
      this.multiItemDialog = false
    },
    chgQty(qty) {
      if (qty == 0 || qty == '' || qty == null || qty == undefined) {
        qty = 1
      }

      if (this.selectedPrcRemainQty != 0) {
        if (this.selectedPrcRemainQty > qty) {
          this.selectedItemQty = Number(qty)
        }
      }
    },
    add() {
      // console.log(this.selectedPrcRemainQty)
      if (this.selectedPrcRemainQty != 0) {
        if (this.selectedPrcRemainQty > this.selectedItemQty) {
          this.selectedItemQty += 1
        }
      }
    },
    sub() {
      if (this.selectedItemQty > 1) {
        this.selectedItemQty -= 1
      }
    },
    setAllPrice() {
      this.selectedPropPrice = []
      this.selectedPropPriceWTax = []
      this.propItemPrice = 0
      this.propItemPriceWTax = 0
      //Cal total prop price per item
      console.log(this.selectedItemPropList)
      if (this.selectedItemPropList.length > 0) {
        for (let i = 0; i < this.selectedItemPropList.length; i++) {
          for (let j = 0; j < this.ListOfProp.length; j++) {
            if (this.selectedItemPropList[i] == this.ListOfProp[j].PropName) {
              const ListOfSelectedPropDetail = []
              ListOfSelectedPropDetail.propName = this.ListOfProp[j].PropName
              ListOfSelectedPropDetail.propPrice = this.ListOfProp[
                j
              ].ItemPropPrc
              ListOfSelectedPropDetail.propPriceWTax = this.ListOfProp[
                j
              ].ItemPropPrcWTax
              this.selectedPropPrice.push(ListOfSelectedPropDetail.propPrice)
              this.selectedPropPriceWTax.push(
                ListOfSelectedPropDetail.propPriceWTax
              )
              this.propItemPrice =
                this.propItemPrice + this.ListOfProp[j].ItemPropPrc
              this.propItemPriceWTax =
                this.propItemPriceWTax + this.ListOfProp[j].ItemPropPrcWTax
              break
            }
          }
        }
        //set multi type prop price per item
        if (this.selectedItemMultiPropList.length > 0) {
          for (let h = 0; h < this.selectedItemMultiPropList.length; h++) {
            for (let i = 0; i < this.selectedItemPropList.length; i++) {
              for (let j = 0; j < this.ListOfProp.length; j++) {
                if (
                  this.selectedItemMultiPropList[h] ==
                  this.selectedItemPropList[i]
                ) {
                  if (
                    this.selectedItemPropList[i].substr(
                      0,
                      this.selectedItemPropList[i].lastIndexOf(' X ')
                    ) == this.ListOfProp[j].PropName
                  ) {
                    const ListOfSelectedPropDetail = []
                    ListOfSelectedPropDetail.propName = this.ListOfProp[
                      j
                    ].PropName

                    let newpropItemPrice =
                      this.ListOfProp[j].ItemPropPrc *
                      this.selectedItemPropList[i].split(' X ')[
                        this.selectedItemPropList[i].split(' X ').length - 1
                      ]

                    ListOfSelectedPropDetail.propPrice = Number(
                      newpropItemPrice.toFixed(2)
                    )

                    let newpropItemPriceWTax =
                      this.ListOfProp[j].ItemPropPrcWTax *
                      this.selectedItemPropList[i].split(' X ')[
                        this.selectedItemPropList[i].split(' X ').length - 1
                      ]

                    ListOfSelectedPropDetail.propPriceWTax = Number(
                      newpropItemPriceWTax.toFixed(2)
                    )
                    this.selectedPropPrice.push(
                      ListOfSelectedPropDetail.propPrice
                    )
                    this.selectedPropPriceWTax.push(
                      ListOfSelectedPropDetail.propPriceWTax
                    )
                    this.propItemPrice =
                      this.propItemPrice + Number(newpropItemPrice.toFixed(2))

                    this.propItemPriceWTax =
                      this.propItemPriceWTax +
                      Number(newpropItemPriceWTax.toFixed(2))
                    break
                  }
                }
              }
            }
          }
        }
      } else {
        this.selectedPropPrice = []
        this.selectedPropPriceWTax = []
        this.propItemPrice = 0
        this.propItemPriceWTax = 0
      }
      // console.log(this.selectedPropPrice)
      // console.log(this.selectedPropPriceWTax)
      // console.log(this.propItemPriceWTax)
      // console.log(this.propItemPrice)
    },
    EditCart() {
      this.snackbar = false
      console.log(this.selectedItemPrc)

      this.setAllPrice()
      console.log(this.InfoOfCart)

      //Add to cart
      if (this.selectedItemPrc == '') {
        this.snackbarMsg = 'Please Select Size!'
        this.colorTxt = 'error'
        this.snackbar = true
      } else {
        //Add Remark
        if (
          this.itemRemark.trim() != '' &&
          this.itemRemark.trim() != undefined
        ) {
          const remakNamePrice = []
          remakNamePrice.propName = this.itemRemark
          remakNamePrice.propPrice = 0
          this.selectedItemPropList.push(remakNamePrice.propName)
          this.selectedPropPrice.push(remakNamePrice.propPrice)
          this.selectedPropPriceWTax.push(remakNamePrice.propPrice)
          this.propItemPrice = this.propItemPrice + 0
          this.propItemPriceWTax = this.propItemPriceWTax + 0
        }

        console.log(this.selectedPropPrice)
        console.log(this.propItemPrice)

        //let foundInCart = false
        if (this.selectedItemPrc != '' && this.selectedItemQty > 0) {
          console.log(this.InfoOfCart)
          // if (this.InfoOfCart.length > 0) {
          //   if (this.prcType == 0) {
          //     for (let i = 0; i < this.InfoOfCart.length; i++) {
          //       if (
          //         this.currentItemId == this.InfoOfCart[i].ID &&
          //         this.selectedItemPrc == this.InfoOfCart[i].size
          //       ) {
          //         if (this.selectedItemPropList.length > 0) {
          //           foundInCart = false
          //           break
          //         } else {
          //           if (this.InfoOfCart[i].prop.length > 0) {
          //             foundInCart = false
          //           } else {
          //             foundInCart = true
          //             this.InfoOfCart[i].qty =
          //               this.InfoOfCart[i].qty + this.selectedItemQty
          //             this.InfoOfCart[i].totalPrice = Number(
          //               (Number(this.InfoOfCart[i].singlePrice) + 0) *
          //                 Number(this.InfoOfCart[i].qty)
          //             )
          //             this.InfoOfCart[i].totalPriceWTax = Number(
          //               (Number(this.InfoOfCart[i].singlePriceWTax) + 0) *
          //                 Number(this.InfoOfCart[i].qty)
          //             )
          //             this.InfoOfCart[i].prop = this.selectedItemPropList
          //             this.InfoOfCart[i].propPrice = this.selectedPropPrice
          //             this.InfoOfCart[
          //               i
          //             ].propPriceWTax = this.selectedPropPriceWTax
          //             this.InfoOfCart[i].propTotalPrice = this.propItemPrice
          //             this.InfoOfCart[
          //               i
          //             ].propTotalPriceWTax = this.propItemPriceWTax

          //             const editIndex = sessionStorage.getItem(
          //               'editItemDetailIndex'
          //             )
          //             if (i != editIndex) {
          //               this.InfoOfCart.splice(
          //                 this.InfoOfCart.indexOf(this.InfoOfCart[editIndex]),
          //                 1
          //               )
          //             }
          //             if (i == editIndex) {
          //               this.InfoOfCart[i].qty = this.selectedItemQty
          //             }

          //             console.log('Add to Cart Item: ', this.InfoOfCart)

          //             this.snackbarMsg = 'Successfully Edited !!!'
          //             this.colorTxt = 'success'
          //             this.snackbar = true
          //           }
          //         }
          //       }
          //     }

          //     if (!foundInCart) {
          //       const cartItem = {
          //         prcType: this.prcType,
          //         ID: this.currentItemId,
          //         PriceID: this.selectedPrcId,
          //         name: this.itemName,
          //         desc: this.itemDesp,
          //         size: this.selectedItemPrc,
          //         qty: this.selectedItemQty,
          //         prop: this.selectedItemPropList,
          //         propPrice: this.selectedPropPrice,
          //         propPriceWTax: this.selectedPropPriceWTax,
          //         propTotalPrice: this.propItemPrice,
          //         propTotalPriceWTax: this.propItemPriceWTax,
          //         memo: '',
          //         itemSmallImg: this.smallSizeImg,
          //         singlePrice: this.itemPrice,
          //         singlePriceWTax: this.itemPriceWTax,
          //         totalPrice: Number(
          //           (Number(this.itemPrice) + Number(this.propItemPrice)) *
          //             Number(this.selectedItemQty)
          //         ),
          //         totalPriceWTax: Number(
          //           (Number(this.itemPriceWTax) +
          //             Number(this.propItemPriceWTax)) *
          //             Number(this.selectedItemQty)
          //         )
          //       }
          //       const editIndex = sessionStorage.getItem('editItemDetailIndex')
          //       this.InfoOfCart[editIndex] = cartItem
          //       console.log('Add to Cart Item: ', this.InfoOfCart)

          //       this.colorTxt = 'success'
          //       this.snackbarMsg = 'Successfully Edited !!!'
          //       this.snackbar = true
          //     }
          //   } else if (this.prcType == 1) {
          //     const cartItem = {
          //       prcType: this.prcType,
          //       ID: this.currentItemId,
          //       PriceID: this.selectedPrcId,
          //       name: this.itemName,
          //       desc: this.itemDesp,
          //       size: this.selectedItemPrc,
          //       qty: this.selectedItemQty,
          //       prop: this.selectedItemPropList,
          //       propPrice: this.selectedPropPrice,
          //       propPriceWTax: this.selectedPropPriceWTax,
          //       propTotalPrice: this.propItemPrice,
          //       propTotalPriceWTax: this.propItemPriceWTax,
          //       memo: '',
          //       itemSmallImg: this.smallSizeImg,
          //       singlePrice: this.itemPrice,
          //       singlePriceWTax: this.itemPriceWTax,
          //       totalPrice: Number(
          //         (Number(this.itemPrice) + Number(this.propItemPrice)) *
          //           Number(this.selectedItemQty)
          //       ),
          //       totalPriceWTax: Number(
          //         (Number(this.itemPriceWTax) +
          //           Number(this.propItemPriceWTax)) *
          //           Number(this.selectedItemQty)
          //       )
          //     }
          //     const editIndex = sessionStorage.getItem('editItemDetailIndex')
          //     this.InfoOfCart[editIndex] = cartItem
          //     console.log('Add to Cart Item: ', this.InfoOfCart)

          //     this.colorTxt = 'success'
          //     this.snackbarMsg = 'Successfully Edited !!!'
          //     this.snackbar = true
          //   }
          // } else {
          const cartItem = {
            prcType: this.prcType,
            ID: this.currentItemId,
            PriceID: this.selectedPrcId,
            name: this.itemName,
            desc: this.itemDesp,
            size: this.selectedItemPrc,
            qty: this.selectedItemQty,
            prop: this.selectedItemPropList,
            propPrice: this.selectedPropPrice,
            propPriceWTax: this.selectedPropPriceWTax,
            propTotalPrice: this.propItemPrice,
            propTotalPriceWTax: this.propItemPriceWTax,
            memo: '',
            itemSmallImg: this.smallSizeImg,
            singlePrice: this.itemPrice,
            singlePriceWTax: this.itemPriceWTax,
            totalPrice: Number(
              (Number(this.itemPrice) + Number(this.propItemPrice)) *
                Number(this.selectedItemQty)
            ),
            totalPriceWTax: Number(
              (Number(this.itemPriceWTax) + Number(this.propItemPriceWTax)) *
                Number(this.selectedItemQty)
            )
          }
          const editIndex = sessionStorage.getItem('editItemDetailIndex')
          this.InfoOfCart[editIndex] = cartItem
          console.log('Add to Cart Item: ', this.InfoOfCart)

          this.colorTxt = 'success'
          this.snackbarMsg = 'Successfully Edited !!!'
          this.snackbar = true
          //}
        }
        this.selectedProp = []
        this.selectedItemPropList = []
        this.selectedItemMultiPropList = []
        if (this.onlyOneSizeToSelect == false) {
          this.selectedItemPrc = ''
        }
        this.selectedItemPropList = []
        this.selectedItemMultiPropList = []

        this.totalCartItemQty = 0
        for (let i = 0; i < this.InfoOfCart.length; i++) {
          this.totalCartItemQty = this.totalCartItemQty + this.InfoOfCart[i].qty
          // console.log(this.totalCartItemQty)
        }

        console.log(this.totalCartItemQty)
        const valueQty = JSON.stringify(this.totalCartItemQty)
        sessionStorage.setItem('TotalCartItemQty', valueQty)

        // console.log('this.InfoOfCart: ', this.InfoOfCart)
        const value = JSON.stringify(this.InfoOfCart)
        // console.log('value: ', value)
        sessionStorage.setItem('cart', value)

        //backToMain
        setTimeout(this.backToPrevPage, 500)
      }
    },
    backToPrevPage() {
      // sessionStorage.setItem('needBackPrevPosition', true)
      sessionStorage.setItem('editItemDetailIndex', '')
      if (globalVar.mode == 'normal') {
        this.$router.replace('/shopping-cart')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'ShoppCart', params: { mchdCode: mchCd } })
      }
    },
    toShopCart() {
      const refIdValue = sessionStorage.getItem('haveRefId')
      this.sendRefId = refIdValue
      if (this.sendRefId == 0 || this.sendRefId == undefined) {
        this.createRefId()
      }

      // console.log(this.sendRefId)
      sessionStorage.setItem(
        'viewShoppingCart',
        JSON.stringify({ status: 'fromItemDetail', itemId: this.currentItemId })
      )
      if (globalVar.mode == 'normal') {
        this.$router.replace('/shopping-cart')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'ShoppCart', params: { mchdCode: mchCd } })
      }
    },
    createRefId() {
      this.sendRefId = new Date().getTime()
      console.log(this.sendRefId)
      sessionStorage.setItem('haveRefId', this.sendRefId)
    }
  }
}
</script>

<style>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
.choices {
  display: inline-block;
  font-size: 14px;
  font-family: century gothic;
  border: 1px solid var(--search-typeBtnSize-selectedType-background_color) !important;
  color: var(--search-typeBtnSize-selectedType-background_color) !important;
  padding: 5px 10px;
  margin: 3px;
  cursor: pointer;
  border-radius: 5px;
}
@media (max-width: 525px) {
  .choices {
    width: 50%;
  }
}

input:checked + label > choices {
  background: var(
    --search-typeBtnSize-selectedType-background_color
  ) !important;
  color: white !important;
}
input:checked + label > .choices {
  background-color: var(
    --search-typeBtnSize-selectedType-background_color
  ) !important;
  color: white !important;
}
.addCartBtn {
  background-color: var(--search-startOrderBtn-background_color) !important;
  color: var(--search-startOrderBtn-color) !important;
}
/* b-button:focus {
  box-shadow: transparent;
  outline: none !important;
  text-shadow: none;
} */
/* .btn-outline-danger:focus,
.btn-outline-danger.focus {
  -webkit-box-shadow: transparent;
  box-shadow: transparent;
  border: none;
}
.btn-outline-primary:focus,
.btn-outline-primary.focus {
  -webkit-box-shadow: transparent;
  box-shadow: transparent;
  border: none;
} */
.iconBorder {
  background-color: rgba(99, 97, 97, 0.5);
  border-radius: 50%;
  width: 35px;
  height: 35px;
}
.iPrice {
  width: 50px;
  padding-left: 0px;
  padding-right: 0px;
}
.setBtnSz {
  min-width: 32px;
}
.itemDetailContain {
  width: 100%;
  background-color: white;
  padding-top: 20px;
  padding-bottom: 20px;
}
.itemDetailImgContain {
  margin-left: 20px;
  float: left;
  max-width: 19%;
}
.itemDetailCardContain {
  margin-right: 20px;
  float: left;
  margin-left: 20px;
  max-width: 81%;
  min-width: 81%;
}
.itemDetailImg {
  width: 300px;
  height: auto;
  display: block;
  margin: auto;
}
@media (max-width: 1912px) {
  .itemDetailImgContain {
    max-width: 25%;
  }
  .itemDetailCardContain {
    max-width: 75%;
    min-width: 75%;
  }
}
@media (max-width: 1457px) {
  .itemDetailImgContain {
    max-width: 30%;
  }
  .itemDetailCardContain {
    max-width: 70%;
    min-width: 70%;
  }
}
@media (max-width: 1263px) {
  .itemDetailImgContain {
    max-width: 40%;
  }
  .itemDetailCardContain {
    max-width: 60%;
    min-width: 60%;
  }
}
@media (max-width: 959px) {
  .itemDetailImgContain {
    max-width: 50%;
  }
  .itemDetailCardContain {
    max-width: 50%;
    min-width: 50%;
  }
}
@media (max-width: 767px) {
  .itemDetailContain {
    /* padding: 0px !important;
    margin: 0px !important; */
    background-color: transparent;
  }
  .itemDetailImgContain {
    float: none;
    max-width: 100%;
  }
  .itemDetailCardContain {
    margin-left: 0px;
    max-width: 100%;
    min-width: 100%;
  }
}
@media (max-width: 555px) {
  .itemDetailContain {
    padding: 0px !important;
    margin: 0px !important;
    background-color: transparent;
  }
}
@media (max-width: 332px) {
  .itemDetailImg {
    width: 100%;
    height: auto;
    display: block;
    margin: auto;
  }
}
</style>
